import React from "react";
import { Box, Grid } from "@mui/material";
import CustomizedAccordions from "../../components/homepage/accordion";
import ContentCards from "../../components/homepage/contentCards";
import CustomContainer from "../../components/layout/container";
import CustomHeader from "../../components/layout/header";

import SAIbanner from "../../images/SAI_Banner_Crop.jpg"
import SAIwheel from "../../images/SAIwheel_180pcBigger.jpg"
import FeedbackOrig from "../../images/FeedbackFaces_Original.jpg"


const SAICaseStudy = () => {
  const breadcrumbData = [
    { name: "Home", link: "/" },
    {
      name: `Case Study (SAI)`,
      link: `/why/case-study/SAI`,
    },
  ];

  return (
    <Box>
      <Grid>
        <title>SAI - Case Study | MEF</title>
        <meta name="description" content="SAI Case Study" />
      </Grid>
      <CustomHeader
        title={"Client Case Study - Financial Advice"}
        breadcrumbData={breadcrumbData}
      />

      <CustomContainer>
        <Box >
          <Grid container spacing={1.5}>
            <Grid item xs={12} sm={6} md={4}>
              <ContentCards
                imgSrc={SAIbanner}
                title="Client Profile-Financial/Investment Advice"
                objectFit="contain"
                subTitle="SAI-helping to deliver suitable advice and build a profitable business"
                //example to link in text
                body={`The SAI was set up by the serial entreprenneur and thought-leader Paul Resnik in 2018 to enhance professionalism within the
                Financial advice/IFA sector- its website states:<br>
                <i>..when you're building financial advice systems or products that will meet suitability requirements things quickly get complex. The SAI brings together 
                tools, information, resources and expertise that will help you navigate your way to suitability, covering: <ul>
                <li><b>Education</b> — Explaining the five core components of ‘suitable advice’ and linking to regulations for major markets </li>
                <li><b>Podcasts</b> — A virtual conference at your desk, with insights into how to build advice systems that  have suitability in their DNA </li>
                <li><b>Blog</b> — Analysis of developments in suitability </li>
                </ul></i> `}
              />
              {/* Whether it be: research into "gentle" robots that can handle delicate items on a production line, working with industry to deliver our leading prosthetics work that helps patients recover their movement more quickly, or students learning about systems that will safely carry people from A to B in autonomous vehicles; */}
              {/* <CustomizedAccordions
                title="Types of Global Risk"
                body={`<ul>
                <li>Macroeconomic - Consumer Demand, Fiscal Tax/Spend, Inflation, Currency</li>
                <li>Supply/Geopolitical- supply disruptions </li>
                <li>Energy - technology breakthroughs and tech-diffusuion</li>
                <li>Carbon Transition - green taxation, technology shocks</li>
                <li>Climate/Physical - flooding, heatwaves, desertification</li>
                </ul>`}
              /> */}
              {/* <CustomizedAccordions
                title="How MEF can help - CASE STUDY"
                body={`We assist many different types of firm deal with the anticipation & quantification of Global risk that will likley impact their domain-level operations.
                One such firm is Decision Analysis Services Ltd which MEF have been working with for almost 25 years <a href='/case-study/DAS'> DAS Case Study</a>`}
              /> */}
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <ContentCards
                imgSrc={SAIwheel}
                title="Client Needs-Applied Risk Education"
                objectFit="contain"
                subTitle={`How SAI work with MEF- Illustrating the 5 "Proofs"`}
                body={`SAI's mission is to ensure that financial advice meets some basic, professional criteria as set out in the 
                SAI wheel above. Knowing how (global) economic shocks can impact both finanical returns and Esg exposure - is a crucial 
                aspect of "Know your product" but also indirectly impacts <i>all</i> proofs. <br><br>
                MEF is thus a regular contributor to the various professional roadshows and education events that SAI stage. 
                A common misconception is any potential returns surprises are "all captured by the Montecarlo risk fan"; but as the GFC, COVID and Ukraine have demonstrated this can be
                a highly complacent assumption by IFAs. The risk2NZ App is also used by Investment Professionals & Financial Advisers to
                quickly guage the impact of various economic/policy shocks on both Portfolio returns & Esg ratings`}
              />
              <CustomizedAccordions
                title="Articulating Macro/Esg risk in Professional Education/CPD"
                body={`See MEF Educational/CPD sessions on Global Risks/Scenarios at the 2018/19 SAI UK Roadshows:
                <ul>
                <li> <a href='https://suitableadviceinstitute.com/suitability-and-economic-shocks'>Suitability impacts of economic shocks</a> </li>
                <li> <a href='https://suitableadviceinstitute.com/advising-around-uncertainty'>Advising around uncertainty</a></li>  </ul>`}
              />
              {/* <CustomizedAccordions
                title="MEF Standard scenarios2"
                body="Fund Managers can then explore/qunatify potential fund risk from key national/global macro & environmental/Esg risks & threats via the Portfolio interrogation form."
              /> */}
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <ContentCards
                imgSrc={FeedbackOrig}
                objectFit="contain"
                title="Client Feedback"
                subTitle={`On MEF's Global Risk Inputs/Education enhances SAI's mission`}
                body={`<i>"..given our role in raising standards in the Financial/Investment advice sector its essential that big picture global risks - that are 
            often ignored as "givens" - are factored into the advice process. MEF's input on both identifying and quantifying how
            global risk "out there" can drastically impact real-world financial outcomes is essential to our wider mission of making
            financial advice fully suitable and ensuring that informed consent has been fully secured...."</i>
            <hr style="color:#00a0a0;height:1px;width:50%;">
            If you would like to initiate an informal chat about how MEF's models/tools/Apps may augment your investment advice offer, please email us
                at: <b style="color:#00a0a0" > finance@mef-uk.com </b>  `}
              />
              {/* <CustomizedAccordions
                title="Emissions Analysis1"
                body="iGEM allows the feed-through of mGEM global/national shocks to 12 industrial sectors (ISIC Rev. 4) across most/all of the major economies covered by mGEM."
              />
              <CustomizedAccordions
                title="Emissions Analysis2"
                body="SME managers can (cost-effectively) explore potential trading risk & opportunities in key global/national industry sectors. MEF can also construct SME-specific weighted indices of overall export prospects across all the SME's key export markets. mGEM shocks at a global/national level can then be translated into market-specific impacts for tailored SME risk analysis."
              /> */}
            </Grid>
          </Grid>
        </Box>
      </CustomContainer>
    </Box>
  );
};

export default SAICaseStudy;
